import { PageHeader, Stack, ViewHeader, ViewItemField } from '@fukuri-admins/ui/common';
import styles from './styles.module.scss';

type GroupDetail = {
  name: string;
  code: string;
  description: string;
  createdAt: string;
  updatedAt: string;
};

type Props = {
  groupDetail: GroupDetail;
  editLink: string;
};

/**
 * グループ詳細のプレゼンテーションコンポーネント
 */
export const GroupDetailPresentation: React.FC<Props> = ({
  groupDetail: { name, code, description, createdAt, updatedAt },
  editLink,
}) => (
  <>
    <PageHeader
      variant='breadcrumb'
      breadcrumbItems={[
        { label: '利用企業', href: '/clients' },
        { label: 'グループ', href: '/groups' },
        { label: name },
      ]}
    />
    <div className={styles.content}>
      <ViewHeader title={name} editLink={editLink} />
      <Stack direction='column' gap={24}>
        <ViewItemField label='グループID' direction='row' value={code} />
        <ViewItemField label='説明' direction='row' value={description} />
        <ViewItemField label='作成日時' direction='row' value={createdAt} />
        <ViewItemField label='更新日時' direction='row' value={updatedAt} />
      </Stack>
    </div>
  </>
);
